import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { matchPath, useLocation } from 'react-router-dom';
import { useIsMobile } from './layout_hooks';
import usePrevious from '../../services/use_previous';
import { useGetUserProfileQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { useTracker } from '../../operations/tracking_operations';
import { END_USER_RECIPES_BOARD_MEAL_ROUTE } from '../../services/routes';

const trackViewMeal = (isMobile, tracker, userProfile) => {
  const counters = ['numMealsViewed'];
  if (isMobile) {
    counters.push('numMealsViewedMobile');
  }
  tracker(userProfile, ['View meal'], counters);
};

const CommonLocationListener = () => {
  const location = useLocation();
  const isMobile = useIsMobile();

  const previousLocation = usePrevious(location);

  const { data: userProfile } = useGetUserProfileQuery();

  const tracker = useTracker();

  const lastUsedViewStartDate = useSelector(
    (state) => state.endUserPlanner.currentPlannerViewWeekStartDate,
  );

  useEffect(() => {
    if (!location) {
      return;
    }

    if (previousLocation && previousLocation.pathname === location.pathname) {
      // Prevent render loop if the path hasn't changed
      return;
    }

    if (matchPath(END_USER_RECIPES_BOARD_MEAL_ROUTE, location.pathname)) {
      /*
      {
    "match": {
        "path": "/recipes/:recipesBoardId/meal/:mealId",
        "url": "/recipes/8ef8a06a-750e-4008-96d7-cb7900b22bbb/meal/a45d0201-8478-48a8-bde4-b4617171f865",
        "isExact": true,
        "params": {
            "recipesBoardId": "8ef8a06a-750e-4008-96d7-cb7900b22bbb",
            "mealId": "a45d0201-8478-48a8-bde4-b4617171f865"
        }
    }
       */
      const counters = ['numMealsViewed'];
      if (isMobile) {
        counters.push('numMealsViewedMobile');
      }
      tracker(userProfile, ['View meal'], counters);
      return;
    }

    const matchPlannerView = matchPath(
      '/planner/:startDate/meal/:mealId',
      location.pathname,
    );
    if (matchPlannerView) {
      // const plannerEntryTypeViewed = plannerEntryType(
      //   plannerWeeks,
      //   matchPlannerView.params.startDate,
      //   matchPlannerView.params.mealId,
      // );
      // if (plannerEntryTypeViewed === 'NOTE') {
      //   const counters = ['numNotesViewed'];
      //   if (isMobile) {
      //     counters.push('numNotesViewedMobile');
      //   }
      //   tracker(userProfile, ['View note'], counters);
      // } else {
      const counters = ['numMealsViewed'];
      if (isMobile) {
        counters.push('numMealsViewedMobile');
      }
      tracker(userProfile, ['View meal'], counters);
      // }
      return;
    }

    const matchDefaultStartDatePlannerView = matchPath(
      '/planner/meal/:mealId',
      location.pathname,
    );
    if (matchDefaultStartDatePlannerView) {
      // const plannerEntryTypeViewed = plannerEntryType(
      //   plannerWeeks,
      //   lastUsedViewStartDate,
      //   matchDefaultStartDatePlannerView.params.mealId,
      // );
      // if (plannerEntryTypeViewed === 'NOTE') {
      //   trackViewNote(isMobile, tracker, userProfile);
      // } else {
      trackViewMeal(isMobile, tracker, userProfile);
      // }
      return;
    }

    if (
      matchPath('/products/:boardId/shoppingList/:mealId', location.pathname)
    ) {
      const counters = ['numShoppingListsViewed'];
      if (isMobile) {
        counters.push('numShoppingListsViewedMobile');
      }
      tracker(userProfile, ['Shopping list viewed'], counters);
    }
  }, [
    tracker,
    isMobile,
    lastUsedViewStartDate,
    location,
    userProfile,
    previousLocation,
  ]);

  return '';
};

export default CommonLocationListener;
